// IMPORTANT: this file was generated using SVGR, please do not edit directly. Refer to the icon README.md for more info.
 
 
import type { FC } from 'react';

import { Icon, type IconProps } from './../IconWrapper';

const SvgEditIcon: FC<IconProps> = ({ color, size, verticalAlign }) => (
  <Icon color={color} size={size} verticalAlign={verticalAlign}>
    <path d="M4.29 15.29c-.13.13-.22.29-.26.47l-.97 3.97c-.08.34.02.7.26.94.19.19.45.29.71.29.08 0 .16 0 .24-.03l3.97-.97c.18-.04.34-.13.47-.26l9.79-9.79-4.41-4.41zM21.71 5.29l-3-3a.996.996 0 0 0-1.41 0l-1.79 1.79 4.41 4.41 1.79-1.79a.996.996 0 0 0 0-1.41" />
  </Icon>
);
export default SvgEditIcon;
SvgEditIcon.displayName = 'SvgEditIcon';
